import React from 'react';
import { ServiceLandingPage } from '../components/ServiceLandingPage';
export function Investors() {
  return <ServiceLandingPage badge="Property Investors" heroHeadline="Build and Scale Your Property Portfolio With Strategy" heroSub="Every purchase should set up the next one." heroCta="Build Your Strategy" problems={["Can't figure out how to buy next property", 'Hit borrowing limits', 'Unsure how to use equity', 'Loan structure not scalable']} videoSectionTitle="Property Investment Strategy Series" videos={[{
    title: 'Using equity to buy next property',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Structuring investment loans',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Portfolio growth strategy',
    id: 'dQw4w9WgXcQ'
  }]} howWeHelp={['Strategy first', 'Structure loans for growth', 'Long-term thinking']} process={[{
    title: 'Map your current portfolio',
    description: 'Assess existing assets and debt.'
  }, {
    title: 'Identify usable equity',
    description: 'Find capital for the next acquisition.'
  }, {
    title: 'Build acquisition plan',
    description: 'Determine what and when you can buy.'
  }, {
    title: 'Structure lending correctly',
    description: 'Avoid cross-collateralisation and limits.'
  }, {
    title: 'Support ongoing purchases',
    description: 'A long-term partnership for growth.'
  }]} scenario="Client used equity to acquire second and third property" showToolSection={true} finalCta="Build Your Strategy" data-id="element-1621" />;
}